module.exports = __webpack_public_path__ + "media/proksee-viewer/images/fb-centerLine-ccd841e48b16b97df720a77c6f9729ea.svg";